<template>
  <div class="main-page">
    <template v-if="showHeader">
      <section class="page-section">
        <div class="container-fluid">
          <div class="grid justify-content-between">
            <div class="col">
              <div class="">
                <div class="text-3xl font-bold">Edit Office</div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <hr />
    </template>
    <section class="page-section pt-3">
      <div class="container-fluid">
        <div class="grid">
          <div class="md:col-9 sm:col-12 comp-grid">
            <div class="">
              <div class="">
                <div>
                  <template v-if="pageReady">
                    <div class="grid">
                      <div class="col-12">
                        <form
                          ref="observer"
                          tag="form"
                          @submit.prevent="submitForm()"
                          class=""
                          :class="{ card: !isSubPage }"
                        >
                          <!--[form-content-start]-->
                          <div class="grid">
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">Region *</div>
                              <div id="ctrl-region-holder">
                                <api-data-source
                                  api-path="components_data/region_option_list"
                                >
                                  <template v-slot="req">
                                    <Dropdown
                                      class="w-full"
                                      :class="getErrorClass('region')"
                                      :loading="req.loading"
                                      optionLabel="label"
                                      optionValue="value"
                                      ref="ctrlregion"
                                      v-model="formData.region"
                                      :options="req.response"
                                      label="Region"
                                      placeholder="Select ..."
                                      :filter="true"
                                    >
                                    </Dropdown>
                                    <small
                                      v-if="isFieldValid('region')"
                                      class="p-error"
                                      >{{ getFieldError("region") }}</small
                                    >
                                  </template>
                                </api-data-source>
                              </div>
                            </div>
                            <div class="col-12 md:col-6">
                              <div class="mb-2 font-bold text-sm">
                                District *
                              </div>
                              <div id="ctrl-district-holder">
                                <api-data-source
                                  @loaded="formData.district = ''"
                                  :load-on-mount="false"
                                  :api-path="`components_data/district_option_list?lookup_region=${formData.region}`"
                                >
                                  <template v-slot="req">
                                    <Dropdown
                                      class="w-full"
                                      :class="getErrorClass('district')"
                                      :loading="req.loading"
                                      optionLabel="label"
                                      optionValue="value"
                                      ref="ctrldistrict"
                                      v-model="formData.district"
                                      :options="req.response"
                                      label="District"
                                      placeholder="Select ..."
                                    >
                                    </Dropdown>
                                    <small
                                      v-if="isFieldValid('district')"
                                      class="p-error"
                                      >{{ getFieldError("district") }}</small
                                    >
                                  </template>
                                </api-data-source>
                              </div>
                            </div>
                            <div class="col-12 md:col-12">
                              <div class="mb-2 font-bold text-sm">
                                Name of Office *
                              </div>
                              <div id="ctrl-name-holder">
                                <check-duplicate
                                  v-model="formData.name"
                                  check-path="components_data/offices_name_exist/"
                                  v-slot="checker"
                                >
                                  <InputText
                                    ref="ctrlname"
                                    @blur="checker.check"
                                    :loading="checker.loading"
                                    v-model.trim="formData.name"
                                    label="Name of Office"
                                    type="text"
                                    placeholder="Enter Name of Office"
                                    class="w-full"
                                    :class="getErrorClass('name')"
                                  >
                                  </InputText>
                                  <small
                                    v-if="isFieldValid('name')"
                                    class="p-error"
                                    >{{ getFieldError("name") }}</small
                                  >
                                  <small
                                    v-if="!checker.loading && checker.exist"
                                    class="p-error"
                                  >
                                    Name already exists</small
                                  >
                                  <small v-if="checker.loading" class="text-500"
                                    >Checking...</small
                                  >
                                </check-duplicate>
                              </div>
                            </div>
                          </div>
                          <!--[form-content-end]-->
                          <div v-if="showSubmitButton" class="text-center my-3">
                            <Button
                              type="submit"
                              label="Update"
                              class=" p-button-rounded"
                              icon="pi pi-send"
                              :loading="saving"
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                  </template>
                  <template v-if="loading">
                    <div class="p-3 text-center">
                      <ProgressSpinner style="width: 50px; height: 50px" />
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script setup>
import { computed, reactive, toRefs, onMounted } from "vue";
import useVuelidate from "@vuelidate/core";
import { required } from "@/services/validators";
import { useApp } from "@/composables/app.js";
import { useEditPage } from "@/composables/editpage.js";
const props = defineProps({
  id: [String, Number],
  pageName: {
    type: String,
    default: "offices",
  },
  routeName: {
    type: String,
    default: "officesedit",
  },
  pagePath: {
    type: String,
    default: "offices/edit",
  },
  apiPath: {
    type: String,
    default: "offices/edit",
  },
  submitButtonLabel: {
    type: String,
    default: "Update",
  },
  formValidationError: {
    type: String,
    default: "Form is invalid",
  },
  formValidationMsg: {
    type: String,
    default: "Please complete the form",
  },
  msgAfterUpdate: {
    type: String,
    default: "Record updated successfully",
  },
  showHeader: {
    type: Boolean,
    default: true,
  },
  showSubmitButton: {
    type: Boolean,
    default: true,
  },
  redirect: {
    type: Boolean,
    default: true,
  },
  isSubPage: {
    type: Boolean,
    default: false,
  },
});
const app = useApp();
const formDefaultValues = Object.assign(
  {
    region: "",
    district: "",
    name: "",
  },
  props.pageData
);
const formData = reactive({ ...formDefaultValues });
function onFormSubmited(response) {
  app.flashMsg(props.msgAfterUpdate);
  if (props.redirect) app.navigateTo(`/offices`);
}
const rules = computed(() => {
  return {
    region: { required },
    district: { required },
    name: { required },
  };
});
const v$ = useVuelidate(rules, formData); //form validation
const page = useEditPage(props, formData, v$, onFormSubmited);
//page state
const {
  submitted, // form api submitted state - Boolean
  saving, // form api submiting state - Boolean
  loading, // form data loading state - Boolean
  pageReady, // if api data loaded successfully
} = toRefs(page.state);
//page computed propties
const {
  apiUrl, // page current api path
  currentRecord, // current page record  - Object
} = page.computedProps;
//page methods
const {
  load, // get editable form data from api
  submitForm, // submit form data to api
  getErrorClass, // return error class if field is invalid- args(fieldname)
  getFieldError, //  get validation error message - args(fieldname)
  isFieldValid, // check if field is validated - args(fieldname)
  // map api datasource  to Select options label-value
} = page.methods;
onMounted(() => {
  const pageTitle = "Edit Office";
  app.setPageTitle(props.routeName, pageTitle); // set browser page title
  load();
});
</script>
<style scoped></style>
<style scoped></style>
